<template>
    <div>
        <div v-if="!loading">
            <div v-if="notifications.length > 0" class="p-2" style="margin-bottom: 100px;">
                <div v-for="notification in notifications" class="mb-2"
                    @click="goToDetailPage(notification.receipt.objectId)">
                    <div class="order-history-card p-2" @click="goToDetailPage(notification.receipt.objectId)">
                        <div :class="['order-history-card-header', getOrderStatusColor(notification.receipt.order)]">
                            <div class="d-flex justify-content-between w-100">
                                <span>{{ getStatusText(notification.receipt) }}</span>
                                {{ showCreatedAtTime(notification.created_at) }}
                            </div>
                        </div>
                        <div class="order-history-card-body">
                            <div class="d-flex p-2">
                                <div>
                                    <div :class="['icon-bg', getOrderStatusColor(notification.receipt.order)]">
                                        <i class="fi fi-rr-bell"></i>
                                    </div>
                                </div>
                                <div class="pl-3 text-left">
                                    <span>{{ $t('order') }} #{{ notification.receipt.order.orderNumber }}</span><br>
                                    <div class="d-flex">
                                        <span class="badge badge-grey p-1 pl-1 pr-2 h6 d-flex align-items-center"
                                            style="white-space: nowrap;border-radius: 20px;">
                                            <span class="circle-badge-grey mr-2"><i
                                                    class="fi fi-rr-usd-circle"></i></span>
                                            {{ summary(notification.receipt.grandTotal) }} THB</span>
                                        <span class="badge badge-grey p-1 pl-1 pr-2 h6 ml-1 d-flex align-items-center"
                                            style="white-space: nowrap;border-radius: 20px;">
                                            <span class="circle-badge-grey mr-2"><i
                                                    :class="getTypeOfOrderIcon(notification.receipt.typeOfOrder)" /></span>
                                            {{ $t(getTypeOfOrderText(notification.receipt.typeOfOrder)) }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="d-flex justify-content-center align-items-center " style="height: 80vh;">
                <div class="text-center p-4">
                    <img src="   https://cdn-icons-png.flaticon.com/512/2501/2501014.png " width="35%" alt="" title=""
                        class="img-small"><br>
                    <h4 class="mt-4">{{ $t('noNotifyNow') }}</h4>
                    <span class="text-description">{{ $t('noNotifyNowDespt') }}</span>
                </div>

            </div>
        </div>
        <div v-else>
            <div class="c-app" style="background-color: #ffffff">
                <div class="c-wrapper">
                    <div class="c-body">
                        <div class="lds-ripple">
                            <div></div>
                            <div></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="background-color: #ffffff;box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);" class="fixed-bottom p-3">
            <CButton class="btn-color-theme" @click="reloadWindow()" block>{{ $t('refresh') }}</CButton>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import util from '@/util/util'
import '@/util/delivery.css'
import notify from '@/services/notify'
import moment from 'moment'
import { CButton } from '@coreui/vue'

export default {
    components: {

    },
    data() {
        return {
            notifications: [],
            loading: false,

        }
    },

    computed: {
        ...mapGetters(['shopLineOA']),
        uid() {
            return `${localStorage.getItem('uid')}`
        },
        shopObjectId() {
            return `${localStorage.getItem('shopObjectId')}`
        },
        shop() {
            return this.shopLineOA.find(
                (detail) => detail.objectId === this.shopObjectId
            )
        },
        shopName() {
            if (this.shop) {
                return this.shop.shopName
            } else {
                return ''
            }
        },
        source() {
            return this.$route.query.source || ''
        },
        logo() {
            const shop = this.shop || {}
            if (shop.remoteImagePath != undefined) {
                return shop.remoteImagePath
            } else {
                return ' https://cdn-icons-png.flaticon.com/512/9718/9718703.png '
            }
        },
    },
    created() {
        this.fetchNotifications()
    },
    methods: {
        ...util,
        goToDetailPage(objectId) {
            this.$router.push(`/delivery/tracking?objectId=${objectId}&redirect=notification`)
        },
        async fetchNotifications() {
            this.loading = true
            const profileObjectId = localStorage.getItem('profileObjectId')

            const res = await notify({
                url: `/notify/v1.0/profile/message/transactions/${profileObjectId}`,
                method: 'get',
            });

            this.notifications = res.data?.data || []
            this.loading = false

        },
        formatTimestamp(timestamp) {
            if (timestamp) {
                return moment(timestamp).format('DD/MM/YYYY, HH:mm');
            } else {
                return 'N/A';
            }
        },
        getOrderStatusColor(order) {
            switch (order.orderStatus) {
                case "NEW":
                    return 'badge-info h6'
                case "ACCEPT":
                    return 'badge-accept h6'
                case "PREPARE":
                    return 'badge-warning h6 text-white'
                case "CANCEL":
                    return 'badge-danger h6'
                case "READY_TO_SHIP":
                    return 'badge-served h6'
                case "SHIPPING":
                    return 'badge-served h6'
                case "FINISH":
                    return 'badge-served h6'
                default:
                    return order.orderStatus
            }
        },
        summary(amount) {
            return util.convertCurrency(amount)
        },
        getTypeOfOrderIcon(type) {
            switch (type) {
                case 1:
                    return 'fi fi-rr-utensils'
                case 3:
                    return 'fi fi-rr-shopping-bag'

                default:
                    return type;
            }
        },
        getTypeOfOrderText(type) {
            switch (type) {
                case 1:
                    return 'dine-in'
                case 3:
                    return 'pickupType'

                default:
                    return type;
            }
        },
        showCreatedAtTime(time) {
            moment.locale(this.$i18n.locale || 'en')
            const timeAgo = time ? moment(time).fromNow() : '-'
            return `${timeAgo}`
        },
        reloadWindow() {
            window.location.reload()
        },
        getStatusText(receipt) {
            switch (receipt?.order?.orderStatus) {
                case "NEW":
                    return this.$t('newOrderIn')
                case "ACCEPT":
                    return this.$t('shopReceivedOrder')
                case "PREPARE":
                    return this.$t('OnPreparing')
                case "CANCEL":
                    return this.$t('cancel')
                case "REJECT":
                    return this.$t('cancel')
                case "READY_TO_SHIP":
                    if (receipt.typeOfOrder == 4) {
                        return this.$t('readyToShip')
                    } else if (receipt.typeOfOrder == 3) {
                        return this.$t('readyForPcikup')
                    } else {
                        return this.$t('readyToServeDelivery')
                    }
                case "SHIPPING":
                    if (receipt.typeOfOrder == 4) {
                        return this.$t('shippingDelivery')
                    } else {
                        return this.$t('readyForPcikup')
                    }
                case "FINISH":
                    return this.$t('finish')
                default:
                    return receipt?.order?.orderStatus
            }
        }
    }

}
</script>
